import { Tag } from "@chakra-ui/react";
import type {
  APIListingApplicantFeedbackEntry,
  APIListingEvent,
  APIListingFeedback,
} from "models/types/api-listing";
import { useWhichWordFactory } from "modules/vendor-portal/hooks/use-which-words";

export function EventOrFeedbackTypeTag({
  type,
  enquirySource,
}: {
  type: APIListingEvent["type"] | APIListingFeedback["type"];
  enquirySource?: APIListingApplicantFeedbackEntry["enquiry_source"];
}) {
  const ww = useWhichWordFactory();
  const label = ww(type.id === "offer" ? "Offer feedback" : type.label);

  return (
    <Tag
      colorScheme={"gray"}
      fontSize={"sm"}
      fontWeight={600}
      color={"gray.600"}
      lineHeight={"16px"}
      py={0.5}
      px={2}
      whiteSpace={"nowrap"}
    >
      {label}
      {enquirySource ? ` from ${enquirySource.label}` : ""}
    </Tag>
  );
}
